<template>
    <div id="bd">
        <div class="row1 fix">
            <div class="wp">
                <div class="tit-i">
                    <h3>灵能智能服务</h3>
                    <h5><span>SERVICE</span></h5>
                </div>
                <ul class="ul-icon-i">
                    <li class="li1">
                        <div class="pad"><a href="#"> <span></span>
                            <h3>灵能云服务</h3>
                            <em></em>
                            <p>进行人工智能、物联网技术研究，并将研究成果转化为云服务，提供诸如车牌识别、人脸识别、语音合成等相关SDK、在线API服务等。</p>
                            <div class="pic"><img src="images/m1.png" alt="灵能智能"> <img src="images/m2.png" alt=""
                                                                                       class="pic-icon"></div>
                        </a></div>
                    </li>
                    <li class="li2">
                        <div class="pad"><a href="#"> <span></span>
                            <h3>业务云服务</h3>
                            <em></em>
                            <p>根据行业业务需求，提供基于SAAS的业务服务云平台，提供业务流转、无纸化办公和线上支付功能。</p>
                            <div class="pic"><img src="images/m1.png" alt="灵能智能"> <img src="images/m4.png"
                                                                                       alt="灵能智能" class="pic-icon">
                            </div>
                        </a></div>
                    </li>
                    <li class="li3">
                        <div class="pad"><a href="#"> <span></span>
                            <h3>大数据分析</h3>
                            <em></em>
                            <p>根据自身业务服务数据对用户进行画像分析，并根据客户需要对其业务数据进行大数据分析。</p>
                            <div class="pic"><img src="images/m1.png" alt="灵能智能"> <img src="images/m6.png"
                                                                                       alt="灵能智能" class="pic-icon">
                            </div>
                        </a></div>
                    </li>
                    <li class="li4">
                        <div class="pad"><a href="/"> <span></span>
                            <h3>灵能机器人</h3>
                            <em></em>
                            <p>以制作服务生活的智能机器人为目标，实现人类的便捷生活，提供服务机器人的租赁、维护和升级工作。</p>
                            <div class="pic"><img src="images/m1.png" alt="灵能智能"> <img src="images/m8.png"
                                                                                       alt="灵能智能" class="pic-icon">
                            </div>
                        </a></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>